import { Bike, Phone, MessageCircle, CheckCircle2 } from "lucide-react";
import SEO from "../components/SEO";
import { ASSETS, BUSINESS, BIKE_SERVICES } from "../lib/data";

export default function OfficinaBici() {
  return (
    <>
      <SEO
        title="Officina Biciclette Roma Nord | Il Velocipede - Riparazione Bici e E-Bike"
        description="Officina biciclette a Roma Nord. Riparazioni, manutenzione, e-bike, regolazione freni e cambio. Servizio professionale a Nuovo Salario e Montesacro."
      />

      {/* HERO */}
      <section className="relative overflow-hidden bg-white border-b border-slate-200" data-testid="bici-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <span className="text-[#fd0100] text-xs uppercase tracking-[0.22em] font-semibold flex items-center gap-2">
              <Bike className="w-4 h-4" /> Officina biciclette
            </span>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight leading-[1.05]">
              Officina Biciclette a Roma Nord
            </h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">
              Riparazione, manutenzione e assistenza completa per biciclette tradizionali ed elettriche. Servizio professionale nel quartiere Nuovo Salario, a un passo da Montesacro.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={`https://wa.me/${BUSINESS.whatsappRaw}?text=Salve%2C%20vorrei%20portare%20la%20mia%20bicicletta%20in%20officina`} target="_blank" rel="noopener noreferrer" data-testid="bici-cta-prenota" className="btn-primary inline-flex items-center gap-2 px-6 py-3.5 rounded-full font-semibold text-sm">
                <MessageCircle className="w-4 h-4" /> Prenota un Intervento
              </a>
              <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="bici-cta-call" className="btn-outline inline-flex items-center gap-2 px-6 py-3.5 rounded-full font-semibold text-sm">
                <Phone className="w-4 h-4" /> {BUSINESS.phoneDisplay}
              </a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="rounded-2xl overflow-hidden aspect-square">
              <img src={ASSETS.workshopBike} alt="Officina biciclette Roma Nord" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="py-20 md:py-28 bg-slate-50" data-testid="bici-services">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mb-14">
            <div className="overline">I nostri servizi</div>
            <div className="divider-red mt-3 mb-6" />
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
              Tutto per la tua bicicletta
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {BIKE_SERVICES.map((s, i) => (
              <div key={i} data-testid={`bici-service-${i}`} className="flex items-start gap-3 bg-white border border-slate-200 rounded-xl p-5 hover:border-[#013368] transition-all">
                <CheckCircle2 className="w-5 h-5 text-[#013368] shrink-0 mt-0.5" />
                <span className="text-slate-800 font-medium text-sm">{s}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEO TEXT */}
      <section className="py-20 md:py-28 bg-white" data-testid="bici-seo">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="overline">Roma Nord</div>
          <div className="divider-red mt-3 mb-6" />
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
            Riparazione biciclette a Montesacro e Nuovo Salario
          </h2>
          <div className="mt-8 space-y-5 text-slate-600 leading-relaxed">
            <p>
              La nostra <strong>officina biciclette a Roma Nord</strong> è attiva da decenni: lavoriamo con bici da città, mountain bike, bici da corsa, bici per bambini e — sempre più — <strong>biciclette elettriche</strong> di tutte le marche e potenze.
            </p>
            <p>
              Offriamo <strong>riparazione biciclette a Montesacro</strong> e <strong>riparazione biciclette a Nuovo Salario</strong> con tempi rapidi e prezzi onesti. Tra gli interventi più richiesti: sostituzione camera d'aria, regolazione cambio e freni, sostituzione catena, revisione completa stagionale, controllo sicurezza e <strong>assistenza per e-bike</strong> (motore, batteria, centralina).
            </p>
            <p>
              Vendiamo e montiamo biciclette nuove, ti aiutiamo a configurare la tua bici ideale e ti supportiamo nella manutenzione periodica per farla durare nel tempo. Passa in negozio per un controllo gratuito o scrivici su WhatsApp: ti rispondiamo entro la giornata.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
